import styled from 'styled-components'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export const SearchFormWrap = styled.div`
    background-color: #f4f4f4;
    padding: 16px 0;
`

export const TotalResult = styled.p`
    padding: 10px 0;
    color: #727b88;
    font-size: 14px;
`

export const ViewMoreButton = styled.button`
    outline: none;
    color: #333;
    font-size: 12px;
    line-height: 26px;
    background-image: linear-gradient(to bottom,rgba(238,238,238,.45),rgba(216,216,216,.45));
    border-radius: 2px;
    border: solid 1px #dbdbdb;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 15px;
    cursor: pointer;
`

export const ViewMoreIcon = styled(ExpandMoreIcon)``

export const PaddingRight = styled.div`
    padding-right: 10px;
`

export const PaddingLeft = styled.div`
    padding-left: 10px;
    height: 100%;
`